import { CommonModule } from "@angular/common";

import { NgModule } from "@angular/core";

// import { MatButtonModule } from "@angular/material/button";

// import { MatCardModule } from "@angular/material/card";

// import { MatCheckboxModule } from "@angular/material/checkbox";

import { MatDialogModule } from "@angular/material/dialog";

// import { MatDividerModule } from "@angular/material/divider";

// import { MatExpansionModule } from "@angular/material/expansion";

// import { MatFormFieldModule } from "@angular/material/form-field";

 import { MatIconModule } from "@angular/material/icon";

// import { MatInputModule } from "@angular/material/input";

// import { MatListModule } from "@angular/material/list";

// import { MatProgressBarModule } from "@angular/material/progress-bar";

// import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

// import { MatSidenavModule } from "@angular/material/sidenav";

// import { MatStepperModule } from "@angular/material/stepper";

// import { MatToolbarModule } from "@angular/material/toolbar";

 

@NgModule({

  declarations: [],

  imports: [CommonModule, MatIconModule],

  exports: [

    // MatStepperModule,

    // MatCheckboxModule,

    // MatInputModule,

    // MatFormFieldModule,

     MatIconModule,

    // MatButtonModule,

    // MatCardModule,

    // MatDividerModule,

    // MatExpansionModule,

    // MatListModule,

    // MatToolbarModule,

    // MatSidenavModule,

    // MatProgressSpinnerModule,

    // MatProgressBarModule,

    MatDialogModule

  ]

})

export class MaterialModule {}

 